<template>
  <div class="wl-display wl-form">
    <section>
      <h4>航线显示设置</h4>
      <label><a-switch size="small" v-model:checked="settings.showWaypoints" /><span class="wl-tri" />航点显示</label>
      <label><a-switch size="small" v-model:checked="settings.showGimbal" /><CompassOutlined />云台朝向显示</label>
      <label><a-switch size="small" v-model:checked="settings.showDropLines" /><ColumnHeightOutlined />对地线显示</label>
      <label><a-switch size="small" v-model:checked="settings.thickLines" /><LineOutlined />粗线模式</label>
    </section>
    <section>
      <h4>航线编辑设置</h4>
      <label><a-switch size="small" v-model:checked="settings.recordAttitude" />新增航点时同步记录姿态信息</label>
      <p class="hint">开启后，从虚拟飞行器新增的航点记录当前机头朝向与云台俯仰角。</p>
      <div class="field">
        <span>航线最小高度提醒 (AGL)</span>
        <a-input-number size="small" :value="settings.minAgl" :min="0" :max="500" :precision="1" @change="setMinAgl" /> m
      </div>
    </section>
  </div>
</template>

<script lang="ts" setup>
import { ColumnHeightOutlined, CompassOutlined, LineOutlined } from '@ant-design/icons-vue'
import { useWaylineEditor } from './editor-context'

const editor = useWaylineEditor()
const settings = editor.settings

function setMinAgl (value: number | null) {
  if (value !== null && Number.isFinite(value)) settings.minAgl = value
}
</script>

<style lang="scss">
.wl-display {
  width: 250px; display: flex; flex-direction: column; gap: 10px;
  section { padding: 10px 12px; border-radius: 6px; background: #24262a; display: flex; flex-direction: column; gap: 8px; }
  h4 { margin: 0; color: #fff; font-size: 12px; font-weight: 600; }
  label { display: flex; align-items: center; gap: 8px; color: #e9eaec; cursor: pointer; }
  .hint { margin: -4px 0 0; color: #9a9ea6; line-height: 1.5; }
  .field { display: flex; flex-direction: column; gap: 6px; color: #c5cbd2; }
  .field .ant-input-number { width: 100px; margin-right: 4px; }
}
</style>
